import { useEffect, useState } from "react";
import { useQuery, useReactiveVar } from "@apollo/client";
import { useParams } from "react-router-dom";

import {
  IInvitedUser,
  IOrganizationIdVariable,
  IRegisteredUser,
  IShowPortalUsersData,
} from "../../interfaces/interfaces";
import {
  organizationIdNameVar,
  selectedUserToShowVar,
  smallHeaderBackArrow,
  smallHeaderTitle,
} from "../apollo/LocalState";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import { GET_PORTAL_USERS_INFO } from "../../api/gqlQueries";
import InviteManagerModal from "../header/InviteManagerModal";
import Spinner from "../Spinner";
import { ReactComponent as Users } from "../../img/propertyDetails/users.svg";
import { UsersTables } from "../tables/UsersTables";

import RemoveManagerModal from "./RemoveManagerModal";

const EditManagers: React.FC = () => {
  const params = useParams();
  let { organizationId } = params;
  if (organizationId === undefined) {
    organizationId = "";
  }
  const organizationIdName = useReactiveVar(organizationIdNameVar);
  useEffect(() => {
    smallHeaderTitle("Admins");
    smallHeaderBackArrow(true);
    return () => {
      smallHeaderTitle("");
      smallHeaderBackArrow(false);
    };
  }, []);
  const [showInviteManagerModal, setShowInviteManagerModal] = useState(false);
  const [showRemoveManagerModal, setRemoveManagerModal] = useState(false);
  const openRemoveManagerModal = (
    user: IRegisteredUser | IInvitedUser | null
  ) => {
    selectedUserToShowVar(user);
    setRemoveManagerModal(true);
  };
  const { loading, data, refetch } = useQuery<
    IShowPortalUsersData,
    IOrganizationIdVariable
  >(GET_PORTAL_USERS_INFO, {
    variables: { organizationId },
  });
  if (loading) {
    return <Spinner />;
  }
  if (!data) {
    throw Error("No data was returned");
  }
  const crumbs = [
    {
      name: organizationIdName.organizationName,
      path: `/${organizationIdName.organizationId}/organization`,
    },
    { name: "Admins", path: "" },
  ];
  const shouldEmptyTableRender =
    data.organization.portalUsers.length === 0 &&
    data.organization.invitedPortalUsers.length === 0;
  return (
    <div className="managers-container center-align">
      {showInviteManagerModal && (
        <InviteManagerModal
          closeModalFn={() => setShowInviteManagerModal(false)}
          refetch={refetch}
          organizationId={organizationId}
        />
      )}
      {showRemoveManagerModal && (
        <RemoveManagerModal
          closeRemoveManagerModal={() => setRemoveManagerModal(false)}
          refetch={refetch}
          organizationName={data.organization.name}
        />
      )}
      <div className="managers-container-inner padding-bottom-large">
        <Breadcrumbs
          crumbs={crumbs}
          rootCrumb={{ name: "Organizations", path: "/" }}
        />
        <div className="managers-header-container">
          <div className="managers-header">
            <div className="managers-header-icon-container">
              <Users title="Users" className="managers-header-icon" />
              <div className="unit-title">Admins</div>
            </div>
            <button
              type="button"
              onClick={() => setShowInviteManagerModal(true)}
              className="managers-header-invite-btn tertiary-btn-small"
            >
              Invite
            </button>
          </div>
        </div>
        <div className="margin-top-small" />
        <div className="managers-description-table">
          <UsersTables
            invitedPortalUsers={data.organization.invitedPortalUsers}
            portalUsers={data.organization.portalUsers}
            shouldEmptyTableRender={shouldEmptyTableRender}
            openRemoveFlowModal={openRemoveManagerModal}
            shouldTrashRender
            shouldGearRender={false}
          />
        </div>
        <button
          onClick={() => setShowInviteManagerModal(true)}
          type="button"
          className="primary-btn managers-btn"
        >
          Invite Admin
        </button>
      </div>
    </div>
  );
};

export default EditManagers;
